/*
 * COPYRIGHT 2022,2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

import { Component } from 'react';
import { EnvironmentViewStyles } from './EnvironmentViewStyles';

class EnvironmentView extends Component {
    getFullName() {
        switch (this.props.data) {
            case "PRD":
                return "PRODUCTION";

            case "STG":
                return "STAGING";

            case "DEV":
                return "DEVELOPMENT";

            default:
                return "-";
        }
    }

    render() {
        return (
            <div style = { EnvironmentViewStyles.getMain() } >
                <div style = { EnvironmentViewStyles.getInnerContainer() } >
                    <div style = { EnvironmentViewStyles.getText() } >
                        { this.getFullName() }
                    </div>
                </div>
            </div>
        )
    }
}

export default EnvironmentView;